define('ua/listeners/careers',['ua/ua-wrapper'], function(ua) {
    'use strict';

    /*
     * COREUI-480
     *
     * EVENTS:
     *  careers.applynow.click
     */
    function setupListeners(edap) {
        var adl = edap.getDL();

        // Only marketing pages will need this
        if (adl.pagetype === 'marketing') {
            edap.on('careers.applynow.click', function(data) {
                var jobname = data.eventlabel || 'undefined';

                if (data.pagename === 'careers: career opportunities') {
                    ua.sendEvent('careers', 'apply now', 'jobslist:' + jobname);
                } else {  // other pagenames are just the job title
                    ua.sendEvent('careers', 'apply now', 'jobdetail:' + jobname);
                }
            });
        }
    }

    return {
        setupListeners: setupListeners
    };
});

